

export class NextEmployeeCodeGenerator implements INextEmployeeCodeGenerator {
    nextEmployeeCode!: number;

    constructor(data?: INextEmployeeCodeGenerator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextEmployeeCode = _data["nextEmployeeCode"];
        }
    }

    static fromJS(data: any): NextEmployeeCodeGenerator {
        data = typeof data === 'object' ? data : {};
        let result = new NextEmployeeCodeGenerator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextEmployeeCode"] = this.nextEmployeeCode;
        return data; 
    }
}

export interface INextEmployeeCodeGenerator {
    nextEmployeeCode: number;
}

